var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagGreenland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0107C0 7.17424 7.1635 0.0107422 16 0.0107422C24.8365 0.0107422 32 7.17424 32 16.0107C31.3044 16.0107 16 18.0977 16 18.0977L0 16.0107Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16.0107C32 24.8472 24.8365 32.0107 16 32.0107C7.1635 32.0107 0 24.8472 0 16.0107",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1307 23.6628C15.3569 23.6628 18.7829 20.2368 18.7829 16.0106C18.7829 11.7844 15.3569 8.3584 11.1307 8.3584C6.90452 8.3584 3.47852 11.7844 3.47852 16.0106C3.47852 20.2368 6.90452 23.6628 11.1307 23.6628Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.47852 16.0106C3.47852 11.7845 6.90452 8.3584 11.1307 8.3584C15.357 8.3584 18.7829 11.7845 18.7829 16.0106",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagGreenland);
export default __webpack_public_path__ + "static/media/flag_greenland.07642db3d7bb7bdd57938c6edcbe3300.svg";
export { ForwardRef as ReactComponent };